/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

import Typesense from 'typesense';

export const typesenseClient = new Typesense.SearchClient({
  apiKey: process.env.REACT_APP_TYPESENSE_API_PUBLIC_KEY ?? '',
  nodes: [
    {
      host: process.env.REACT_APP_TYPESENSE_HOST ?? '',
      port: 443,
      protocol: 'https',
    },
  ],
  sendApiKeyAsQueryParam: true,
  additionalHeaders: {},
});

export const additionalSearchParameters = {
  query_by: 'name,item_id,online_description,brand,embedding,l1_category,l2_category',
  sort_by: '',
  exclude_fields: 'embedding',
};
